import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilitiesService } from '../../../../services/utilities.service';
import { CommercialDocumentTypeService } from '../../../../services/commercial-document-type.service';
import { CommercialDocumentType } from 'src/app/models/commercial-document-type';
import { CommercialDocument } from 'src/app/models/commercial-document';
import { Travel } from '../../../../models/travel';
import { CommercialDocumentService } from '../../../../services/commercial-document.service';
import { AuthService } from '../../../../services/auth.service';
import { CommercialDocumentLine } from '../../../../models/commercial-document-line';
import { User } from 'src/app/models/user';
import { find } from 'lodash';
import * as _ from 'lodash';

@Component({
  selector: 'app-commercial-documents-form',
  templateUrl: './commercial-documents-form.component.html',
  styleUrls: ['./commercial-documents-form.component.css']
})
export class CommercialDocumentsFormComponent implements OnInit {

  loading: boolean = false;
  commercialDocumentTypes: CommercialDocumentType[] = [];
  //commercialDocumentLines: CommercialDocumentLine[] = [];
  commercialDocument: CommercialDocument = new CommercialDocument();
  cdl: CommercialDocumentLine = new CommercialDocumentLine();
  @Input() travel: Travel;
  @Output() storeData = new EventEmitter<string>();
  @Output() updateData = new EventEmitter<string>();
  @Input() newDocument: boolean;
  @Input() commercialDocumentUpd;
  @Output() updCanCreateDocument = new EventEmitter<boolean>();
  documentType: CommercialDocumentType = new CommercialDocumentType();
  currentUser: User = new User();
  currentUserName: string = null;
  //Editar Totales
  checkRetention: boolean = true;
  checkRetentionISR: boolean = true;
  checkIva: boolean = true;
  checkTotal: boolean = true;
  canCreateDocument: boolean = true;

  constructor(private auth:AuthService, private commercialDocumentTypeService: CommercialDocumentTypeService, private toast: ToastrManager, private utl: UtilitiesService, private commercialDocumentService: CommercialDocumentService) { }

  ngOnInit() {
    if(this.newDocument)
    {
      this.getDocumenTypeByTravelId(this.travel.id);
      this.commercialDocument.travel_id = this.travel.id;
      this.currentUser = this.auth.getActualUser();
      this.commercialDocument.user_id = this.currentUser.id;
      this.commercialDocument.user = this.currentUser; //Se puede omitir
      this.currentUserName = this.commercialDocument.user.name + ' ' + this.commercialDocument.user.last_name;
    }else{
      this.getDocumentTypes();
      this.commercialDocument = this.commercialDocumentUpd;
    }
  }

  getDocumenTypeByTravelId(travel_id){
    this.loading = true;
    this.commercialDocumentTypeService.getDocumentTypeByTravelID(travel_id).subscribe( response => {
      this.commercialDocumentTypes = response;
      this.commercialDocumentTypes = _.filter(this.commercialDocumentTypes, (e) => e.id != 4); //Quitamos la opcion de "Factura de Reserva"
      this.canCreateDocument = (this.commercialDocumentTypes.length > 0) ? true : false;
      this.updCanCreateDocument.emit(this.canCreateDocument);
      this.loading = false;
    }, error => {
      this.loading = false;
      this.toast.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
    });
  }

  getDocumentTypes(){
    this.loading = true;
    this.commercialDocumentTypeService.getDocumentTypes().subscribe( response => {
      this.commercialDocumentTypes = response;
      this.commercialDocumentTypes = _.filter(this.commercialDocumentTypes, (e) => e.id != 4); //Quitamos la opcion de "Factura de Reserva"
      this.loading = false;
      this.documentType = this.commercialDocumentTypes.find(e => e.id == this.commercialDocument.commercial_document_type_id);
    }, error => {
      this.loading = false;
      this.toast.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
    });
  }

  selectDocumentType(){
    if(this.commercialDocument.commercial_document_type_id != 0){
      this.documentType = this.commercialDocumentTypes.find(e => e.id == this.commercialDocument.commercial_document_type_id);
    }else{
      this.documentType = new CommercialDocumentType();
      this.commercialDocument.document_number = null;
      this.commercialDocument.retention = 0;
      this.commercialDocument.retention_isr = 0;
      this.commercialDocument.iva = 0;
      this.commercialDocument.subtotal = 0;
      this.commercialDocument.total = 0;
      this.commercialDocument.description = null;
    }
  }

  submitForm(){
    if(this.newDocument)
      this.store();
    else if(!this.newDocument)
      this.update();
  }

  store(){
    this.loading = true;
    this.addLineDefaultDocument();
    this.commercialDocumentService.store(this.commercialDocument).subscribe( response => {
      this.storeData.emit(this.setFormatCommercialDocumentType(this.documentType.id) + ' ' + this.documentType.document + ' del viaje ' + this.travel.id + ' se ha creado correctamente');
      this.setDefaultData();
      this.loading = false;
    }, error =>{
      this.loading = false;
      this.toast.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true});
    });
  }

  addLineDefaultDocument(){
    this.cdl.description = this.commercialDocument.description ? this.commercialDocument.description : null;
    this.commercialDocument.lines.push(this.cdl);
  }

  setDefaultData(){
    this.commercialDocument = new CommercialDocument();
  }

  update(){
    this.loading = true;
    this.commercialDocumentService.update(this.commercialDocument).subscribe( response => {
      this.updateData.emit(this.setFormatCommercialDocumentType(this.documentType.id) + ' ' + this.documentType.document + ' del viaje ' + this.travel.id  + ' se ha actualizado correctamente');
      this.setDefaultData();
      this.loading = false;
    }, error => {
      this.loading = false;
      this.toast.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true});
    });
  }

  setFormatCommercialDocumentType(type: number): string{ return (type == 5) ? 'El' : 'La'; }

  setTotales(){
    switch(this.documentType.id){
      case 1://Factura
        this.commercialDocument.iva = this.commercialDocument.subtotal * 0.16; //IVA 16%
        this.commercialDocument.retention = this.commercialDocument.subtotal * 0.04; //4% servicios de autotransportes
        this.commercialDocument.retention_isr = (this.checkRetentionISR) ? this.commercialDocument.subtotal * 0.0125 : 0; //1.25%
        if(this.checkRetentionISR)
          this.commercialDocument.total = this.commercialDocument.iva + this.commercialDocument.subtotal - this.commercialDocument.retention - this.commercialDocument.retention_isr;
        else
          this.commercialDocument.total = this.commercialDocument.iva + this.commercialDocument.subtotal - this.commercialDocument.retention;
      break;
      case 2://Nota de Cargo
        this.commercialDocument.iva = this.commercialDocument.subtotal * 0.16;
        this.commercialDocument.retention = this.commercialDocument.subtotal * 0.04; //4% servicios de autotransportes
        this.commercialDocument.retention_isr = (this.checkRetentionISR) ? this.commercialDocument.subtotal * 0.0125 : 0;
        if(this.checkRetentionISR)
          this.commercialDocument.total = this.commercialDocument.iva + this.commercialDocument.subtotal - this.commercialDocument.retention - this.commercialDocument.retention_isr;
        else
          this.commercialDocument.total = this.commercialDocument.iva + this.commercialDocument.subtotal - this.commercialDocument.retention;
      break;
      case 3://Nota de Credito
        this.commercialDocument.iva = this.commercialDocument.subtotal * 0.16;
        this.commercialDocument.retention = this.commercialDocument.subtotal * 0.04;
        this.commercialDocument.retention_isr = (this.checkRetentionISR) ? this.commercialDocument.subtotal * 0.0125 : 0;
        if(this.checkRetentionISR)
          this.commercialDocument.total = this.commercialDocument.iva + this.commercialDocument.subtotal - this.commercialDocument.retention - this.commercialDocument.retention_isr;
        else
          this.commercialDocument.total = this.commercialDocument.iva + this.commercialDocument.subtotal - this.commercialDocument.retention;
      break;
      case 5://Complemento de Factura
        this.commercialDocument.iva = this.commercialDocument.subtotal * 0.16;
        this.commercialDocument.retention = this.commercialDocument.subtotal * 0.04;
        this.commercialDocument.retention_isr = (this.checkRetentionISR) ? this.commercialDocument.subtotal * 0.0125 : 0;
        if(this.checkRetentionISR)
          this.commercialDocument.total = this.commercialDocument.iva + this.commercialDocument.subtotal - this.commercialDocument.retention - this.commercialDocument.retention_isr;
        else
          this.commercialDocument.total = this.commercialDocument.iva + this.commercialDocument.subtotal - this.commercialDocument.retention;
      break;
    }
  }

  setRetentionEdit() { 
    this.checkRetention = (this.checkRetention) ? false : true;
    this.commercialDocument.retention = this.commercialDocument.retention ? this.commercialDocument.retention : 0;
  }

  setRetentionISREdit() { 
    this.checkRetentionISR = (this.checkRetentionISR) ? false : true;
    this.commercialDocument.retention_isr = this.commercialDocument.retention_isr ? this.commercialDocument.retention_isr : 0;
  }

  setIvaEdit(){ 
    this.checkIva = (this.checkIva) ? false : true;
    this.commercialDocument.iva = this.commercialDocument.iva ? this.commercialDocument.iva : 0;
  }

  setTotalEdit(){ 
    this.checkTotal = (this.checkTotal) ? false : true;
    this.commercialDocument.total = this.commercialDocument.total ? this.commercialDocument.total : 0;
  }
}
